// Genvas 团队管理(admin 跨团队只读监控)
// admin-dashboard 跨团队视图文案,key 命名空间 team.admin.*
export default {
  // ===== 列表页 =====
  'team.admin.list.title': '团队管理',
  'team.admin.list.description':
    '平台管理员视角:监控全部团队元数据 / 成员数 / 会员',
  'team.admin.list.searchPlaceholder': '搜索团队名或 ID',
  'team.admin.list.refresh': '刷新',
  'team.admin.list.query': '查询',
  'team.admin.list.tableTotal': '共 {total} 个团队',
  'team.admin.list.empty': '暂无团队',

  'team.admin.list.column.name': '团队',
  'team.admin.list.column.owner': '所有者',
  'team.admin.list.column.memberCount': '成员数',
  'team.admin.list.column.membership': '会员',
  'team.admin.list.column.createdAt': '创建时间',
  'team.admin.list.column.updatedAt': '最近活跃',
  'team.admin.list.column.action': '操作',
  'team.admin.list.action.detail': '详情',
  'team.admin.list.copyId': '复制 Team ID',
  'team.admin.list.copyOwnerId': '复制 owner uid',
  'team.admin.list.copySuccess': '已复制',
  'team.admin.list.membership.empty': '未开通',
  'team.admin.list.membership.todoBackend':
    '会员摘要列等后端 batch 接口实装(Phase 5+)',

  // ===== 详情 Modal =====
  'team.admin.detail.title': '团队详情',
  'team.admin.detail.tab.basic': '基本信息',
  'team.admin.detail.tab.members': '成员管理',
  'team.admin.detail.tab.membership': '会员',
  'team.admin.detail.refresh': '刷新',
  'team.admin.detail.loadFailed': '加载团队详情失败',

  // ----- 基本信息 Tab -----
  'team.admin.detail.basic.name': '团队名称',
  'team.admin.detail.basic.slug': 'Slug',
  'team.admin.detail.basic.slugEmpty': '未设置',
  'team.admin.detail.basic.teamId': 'Team ID',
  'team.admin.detail.basic.owner': '所有者',
  'team.admin.detail.basic.memberCount': '成员数',
  'team.admin.detail.basic.createdAt': '创建时间',
  'team.admin.detail.basic.updatedAt': '最近活跃',

  // ----- 成员 Tab(只读) -----
  'team.admin.members.title': '成员列表',
  'team.admin.members.loadFailed': '加载成员列表失败',
  'team.admin.members.column.userId': 'User ID',
  'team.admin.members.column.role': '角色',
  'team.admin.members.column.joinedAt': '加入时间',
  'team.admin.members.role.owner': '所有者',
  'team.admin.members.role.admin': '管理员',
  'team.admin.members.role.member': '成员',
  'team.admin.members.role.viewer': '观察者',

  // ----- 会员 Tab -----
  'team.admin.membership.title': '团队会员管理',
  'team.admin.membership.todoBackend':
    '团队会员列表接口尚未提供(Phase 5 实接 team_memberships 集合)。当前仅可手动开通新会员,占位接口已通,但 Phase 1 stub 不写库,Phase 5 起持久化生效。',
  'team.admin.membership.grantButton': '开通新会员',
  'team.admin.membership.grant.title': '为团队开通新会员',
  'team.admin.membership.grant.warning':
    'Phase 1 接口为占位实现:返回 200 但不持久化。Phase 5 起真正写入 team_memberships。',
  'team.admin.membership.grant.planLabel': '选择方案',
  'team.admin.membership.grant.planPlaceholder': '选择会员方案',
  'team.admin.membership.grant.durationLabel': '时长覆盖(天,留空 = 默认)',
  'team.admin.membership.grant.creditsLabel': 'Credit 覆盖(留空 = 默认)',
  'team.admin.membership.grant.noteLabel': '备注(可选)',
  'team.admin.membership.grant.successPersisted': '已为团队开通会员',
  'team.admin.membership.grant.successStub':
    '接口已接受(Phase 1 stub:未持久化,Phase 5 生效)',
  'team.admin.membership.grant.failed': '开通失败',
};
